<template>
  <div>
    <app-loading v-if="isLoading"></app-loading>
    <main class="book-detail main-top-space" v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getBookDetail" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <div class="card card--no-bottom-border">
          <div class="card__inner">
            <div class="card__photo">
              <div class="ranking-label" v-if="rankingNumber">
                <span class="ranking-label__number">{{rankingNumber}}</span>
                <img src="/static/img/ranking_gold.png" alt="" class="ranking-label__bg" v-if="rankingNumber === 1">
                <img src="/static/img/ranking_silver.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 2">
                <img src="/static/img/ranking_bronz.png" alt="" class="ranking-label__bg" v-else-if="rankingNumber === 3">
                <img src="/static/img/ranking_red.png" alt="" class="ranking-label__bg" v-else>
              </div>
              <img :src="bookDetail.img_url" alt="" class="detail-book-img">
            </div>
            <section class="card__body card-body card-body--book-detail">
              <h4 class="card-body__ttl">{{bookDetail.name_book}}</h4>
              <p class="card-body__author">著者：<span>{{bookDetail.author}}</span></p>
              <!-- <app-star :rate="bookDetail.rating"></app-star> -->
              <p class="card-body__coupon-price" v-if="isCouponShow">割引価格： <span>￥{{bookDetail.discounted_price_jp}}</span></p>
              <p class="card-body__abc-price" v-if="!isCouponShow">abceed版価格： <span>￥{{bookDetail.price_jp}}</span></p>

              <div v-if="discountPrice <= 0">
                <p class="card-body__book-price">紙の本の価格： ￥{{bookDetail.price_jp_book}}</p>
              </div>
              <div v-else-if="bookDetail.price_jp_book < bookDetail.price_jp">
              </div>
              <div v-else>
                <p class="card-body__book-price">紙の本の価格： <span>￥{{bookDetail.price_jp_book}}</span></p>
                <p class="card-body__discount">￥{{discountPrice}}の割引({{discountRate | percentFormatInt }})</p>
              </div>
              <p class="card-body__book-supplement" v-if="priceSupplementText">{{priceSupplementText}}</p>

              <p class="card-body__book-price" v-if="isCouponShow">適用割引：{{couponText}}</p>
            </section>
            <span class="btn-square card__pc-purchase pc-on" @click="click_purchase()" v-if="!hasPurchased" :class="{isActive: (isCreditCardAvailable && !hasPurchased)}">購入する</span>
            <span v-else class="btn-square btn-square--disabled card__pc-purchase pc-on" :class="{isActive: (isCreditCardAvailable && !hasPurchased)}">購入済み</span>
            <p v-if="isCreditCardAvailable && !hasPurchased" class="card__purchase-alert">ボタンを押すと注文が確定されます。</p>
          </div>
          <div class="card-purchase sp-on">
            <span class="btn-square" @click="click_purchase()" v-if="!hasPurchased">購入する</span>
            <span v-else class="btn-square btn-square--disabled">購入済み</span>
            <div class="card-purchase__main">
              <p v-if="isCreditCardAvailable && !hasPurchased">ボタンを押すと注文が確定されます。</p>
              <p class="card-purchase__globee"><a href="https://www.globeejapan.com/" target="_blank">販売元：株式会社Globee</a></p>
            </div>
          </div>
        </div>

        <section class="book-information">
          <section class="book-intro" v-if="bookDetail.contents_description">
            <h3 class="short-ttl">内容紹介</h3>
            <div class="book-intro__sentence">
              <p v-if="isDescriptionMoreBtnShown">{{bookDetail.contents_description | descriptionLimit}}</p>
              <p v-else v-html="bookDetail.contents_description.replace(/\r?\n/g, '<br>')"></p>
              <a href="javascript:void(0);" class="btn btn--reverse btn--max" v-if="isDescriptionMoreBtnShown" @click="showDescription">全て表示</a>
            </div>
          </section>
          <!-- <section class="book-review">
            <h3 class="short-ttl">レビュー</h3>
            <section class="review-main-card" v-if="isReviewShown">
              <div class="book-review-stars">
                <app-star :rate="reviewList.rating"></app-star>
                <div class="book-review-stars__caption">
                  <p>{{reviewList.create_at}} {{reviewList.name_reviewer}}</p>
                </div>
              </div>
              <p class="book-review__sentence">{{reviewList.message}}</p>
            </section>
            <section v-else class="book-blank-review">
              <p>レビューはまだありません。</p>
            </section>
            <p class="book-review__others" v-if="isReviewShown"><router-link :to="'/books/' + $route.params.id + '/reviews'">残り{{restReviewLength}}件のレビューも表示＞</router-link></p>
            <p class="book-review__others" v-else><router-link :to="'/books/' + $route.params.id + '/reviews/add'">レビューを投稿する＞</router-link></p>
          </section> -->
          <section class="book-recommend">
            <h3 class="short-ttl">よく一緒に購入されている教材</h3>
            <section class="book-recommend__cards">
              <app-book v-for="(book, index) in recommendList" :bookInfo="book" :isFirst="index === 0" :key="book.id_book" :isLink="true"></app-book>
            </section>
          </section>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
  import TopInformation from '../common/TopInformation.vue';
  import Book from '../books/Book.vue';
  import { topInformation, credit } from '../../constants';
  import Star from '../smallParts/Star.vue';
  import _ from 'lodash';
  import Loading from '../common/Loading.vue';
  import $ from 'jquery';

  export default {
    headerTitle: '教材詳細',
    headerType: 'historyBack',
    components: {
      appTopInformation: TopInformation,
      appBook: Book,
      appStar: Star,
      appLoading: Loading
    },
    data() {
      return {
        topInformation,
        bookDetail: {
          rating: ''
        },
        recommendList: [],
        priceSupplementText: '',
        discountPrice: '',
        discountRate: '',
        isDescriptionMoreBtnShown: false,
        isReviewShown: false,
        restReviewLength: null,
        reviewList: {},
        rankingNumber: null,
        isCreditCardAvailable: false,
        couponList: [],
        isCouponShow: false,
        couponText: "",
        responseError: false
      }
    },
    created() {
      this.getBookDetail();
    },
    mounted() {
      this.makeBackBtn();
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      },
      hasPurchased() {
        return this.$store.getters.bookDetail.has_purchased;
      }
    },
    methods: {
      makeTDK(nameBook) {
        document.title = `${nameBook} | abceed（No.1 TOEIC教材アプリ）`;
        const metaDiscre = document.head.children;
        const metaLength = metaDiscre.length;
        for (let i = 0; i < metaLength; i++) {
          let dis = metaDiscre[i];
        	let proper = dis.getAttribute('name');
        	if (proper === 'description') {
        		dis.setAttribute('content', `${nameBook}がスマホアプリで学習できる！WEBストア経由で購入すればアプリ価格の10%OFFのキャンペーンを実施中！`);
        	} else if (proper === 'keywords') {
        		dis.setAttribute('content', `${nameBook},教材詳細,toeic,abceed,globee`);
          }
        }
      },
      getBookDetail() {
        this.$store.dispatch("changeLoadingCondition", true);
        let apiUrl = 'webstore/book/detail?id_book=' + this.$route.params.id;
        if (this.$route.query.token) {
          apiUrl += '&token=' + this.$route.query.token
        }
        if (this.$route.query.type) {
          apiUrl += '&type=' + this.$route.query.type
        }

        this.$http.get(apiUrl)
          .then(res => {
            return res.json();
          }, err => {
            return err.json();
          }).then(data => {
            if (data.message === 'error') {
              this.$store.dispatch("changeLoadingCondition", false);
              this.responseError = true;
              return;
            }
            this.makeTDK(data.detail.name_book);
            this.couponList = data.user_coupon_list;
            if (this.couponList.length > 0) {
              this.isCouponShow = true;
              const couponLength = this.couponList.length;
              for (let i = 0; i < couponLength; i++) {
                let coupon = this.couponList[i];
                if (this.couponText !== "") {
                  this.couponText += ","
                }
                this.couponText += coupon.name_coupon
              }
            }
            this.bookDetail = data.detail;
            this.recommendList = data.recommend_book_list;
            if (data.detail.review_list.length > 0) {
              this.restReviewLength = data.detail.review_list.length - 1;
              this.reviewList = data.detail.review_list[0];
              this.isReviewShown = true;
            }
            this.priceSupplementText = this.bookDetail.price_supplement_text;

            if (this.bookDetail.price_jp_book < this.bookDetail.price_jp) {
              this.discountPrice = this.bookDetail.price_jp / 0.9 - this.bookDetail.discounted_price_jp;
              this.discountRate = this.discountPrice / (this.bookDetail.price_jp / 0.9);
            } else {
              this.discountPrice = this.bookDetail.price_jp_book - this.bookDetail.discounted_price_jp;
              this.discountRate = this.discountPrice / this.bookDetail.price_jp_book;
            }

            this.descriptionLengthCheck();
            this.checkIsCreditCardAvailable(data);

            //ログイン成功の場合はログイン処理を行う
            if (data.has_logined) {
              if (data.login_info) {
                this.$store.dispatch("setLogin", data.login_info);
              }
            }
            this.$store.dispatch("setBookDetail", data.detail);
            if (this.$route.query.result === "ok" || this.$route.query.result === "error" || this.$route.query.result === "cancel") {
              //決済からのリダイレクトの場合は左上のボタンをランキング画面へのリンクに変更
              $('.header__back').remove();
              $('.header__ttl').after('<a href="/" class="header__back"><i class="fas fa-chevron-left"></i></a>')
              if (this.$route.query.result === "ok") {
                this.$store.dispatch("showLightBox", "bookDetailResult");
              } else {
                alert('購入に失敗しました。ご利用した決済手段が有効かどうか確認してください。');
              }
            }
            this.$store.dispatch("changeLoadingCondition", false);

            if (this.$store.getters.bookRanking.length === 0) {
              this.$store.dispatch("getBookRanking", {})
                .then(() => {
                  this.getRanking();
                });
            } else {
              this.getRanking();
            }

          })
          .catch(err => {
            this.responseError = true;
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      click_purchase() {
        if (this.isCreditCardAvailable) {
          //クレカ購入済みの場合はその場で決済させる
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("purchaseByToken", {
            ignore_token: true,
            id_book: this.bookDetail.id_book
          }).then(data => {
            if (data.result) {
              //購入成功
              this.$store.dispatch("setPurchased", true);
              this.$store.dispatch("showLightBox", "bookDetailResult");
            } else {
              this.$store.dispatch("hideLightBox");
              alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
            alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
          });
        } else {
          //購入方法選択画面へ
          this.$router.push({name: 'paymentWay'});
        }
      },
      getRanking() {
        this.$store.getters.bookRanking.forEach((e, i) => {
          if (e.id_book === this.$route.params.id) {
            this.rankingNumber = i + 1;
          }
        });
      },
      descriptionLengthCheck() {
        this.isDescriptionMoreBtnShown = this.bookDetail.contents_description && this.bookDetail.contents_description.length >= 120;
      },
      showDescription() {
        this.isDescriptionMoreBtnShown = false;
      },
      makeBackBtn() {
        const targetQuery = this.$route.query.from;
      },
      checkIsCreditCardAvailable(data) {
        this.isCreditCardAvailable = ('sbps_payment_type' in data && data.sbps_payment_type === credit);
      }
    }
  }
</script>

<style scoped lang="scss">
  .review-main-card {
  }
  .book-blank-review {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/books/BookDetail.vue